import * as React from "react"
import { BeautifulMentionsMenuItemProps } from "lexical-beautiful-mentions"
import cs from "classnames"

import styles from "./VariablesPlugin.module.scss"

const _MenuItem = (
  { selected, ...props }: BeautifulMentionsMenuItemProps,
  ref: React.LegacyRef<HTMLLIElement> | undefined
) => (
  <li className={cs(styles.menuItem, { [styles.selected]: selected })} ref={ref} {...props}>
    {props.label.replace("}}", "")}
  </li>
)

export const MenuItem = React.forwardRef<HTMLLIElement, BeautifulMentionsMenuItemProps>(_MenuItem)
